import { refreshLoadedFileSliceDispatch } from "../../Constants/ReduxConstants";

//Every reducer needs initial state.
const initialState = []

export default function refreshLoadedFileSlice(state = initialState, action) {
    switch (action.type) {
        case refreshLoadedFileSliceDispatch.setIsLoading: {
            return {
                ...state,
                isLoading: action.payload
            }
        }
        default:
            return state
    }
}
